import React, { Component } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import './scss/style.scss'
import SmoothScroll from "smooth-scroll";
import '@fortawesome/fontawesome-svg-core/styles.css'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 200,
  speedAsDuration: true,
});

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Forgot = React.lazy(() => import('./views/sign/forgot'))
const UpdatePass = React.lazy(() => import('./views/sign/updatePass'))
const Activate = React.lazy(() => import('./views/sign/activate'))
const Login = React.lazy(() => import('./views/sign/Login'))
const Register = React.lazy(() => import('./views/sign/Register'))
const Applications = React.lazy(() => import('./views/others/applications'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
            <Route exact path="/forgot" name="Forgot Page" render={(props) => <Forgot {...props} />} />
            <Route exact path="/updatePass" name="Update Pass Page" render={(props) => <UpdatePass {...props} />} />
            <Route exact path="/activate" name="Update Pass Page" render={(props) => <Activate {...props} />} />
            <Route exact path="/applications" name="Applications Page" render={(props) => <Applications {...props} />} />
             <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            /> 
            <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
            <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    )
  }
}

export default App
